// 開發進度: 已完成 contained 樣式的 large、medium、small 三種尺寸的按鈕，並設定了三種顏色的主題，分別為 primary、warning、neutral
import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

const StyledButton = styled(Button)(
  ({ theme, size, color, variant, fullWidth }) => ({
    width: fullWidth ? '100%' : 'fit-content',
    borderRadius: '4px',
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: theme.typography.fontWeightRegular,
    // Large button styles
    ...(size === 'large' && {
      padding: variant === 'outlined' ? '15px 19px' : '16px 20px',
      minHeight: '56px',
      fontSize: theme.typography.bodyLarge.fontSize,
      '& .MuiButton-startIcon, & .MuiButton-endIcon': {
        '& > *:first-of-type': {
          fontSize: '24px',
        },
      },
      '& .MuiButton-startIcon': {
        marginRight: '8px',
        marginLeft: 0,
      },
      '& .MuiButton-endIcon': {
        marginRight: 0,
        marginLeft: '8px',
      },
    }),

    // Medium button styles
    ...(size === 'medium' && {
      padding: variant === 'outlined' ? '11px 15px' : '12px 16px',
      minHeight: '44px',
      fontSize: theme.typography.bodyMedium.fontSize,
      '& .MuiButton-startIcon, & .MuiButton-endIcon': {
        '& > *:first-of-type': {
          fontSize: '20px',
        },
      },
      '& .MuiButton-startIcon': {
        marginRight: '6px',
        marginLeft: 0,
      },
      '& .MuiButton-endIcon': {
        marginRight: 0,
        marginLeft: '6px',
      },
    }),

    // Small button styles
    ...(size === 'small' && {
      padding: variant === 'outlined' ? '9px 11px' : '10px 12px',
      minHeight: '37px',
      fontSize: theme.typography.bodySmall.fontSize,
      '& .MuiButton-startIcon, & .MuiButton-endIcon': {
        '& > *:first-of-type': {
          fontSize: '16px',
        },
      },
      '& .MuiButton-startIcon': {
        marginRight: '4px',
        marginLeft: 0,
      },
      '& .MuiButton-endIcon': {
        marginRight: 0,
        marginLeft: '4px',
      },
    }),
    // 狀態設定
    '&.Mui-disabled': {
      backgroundColor: theme.palette.background.disabled,
      color: theme.palette.text.disabled,
    },
    // 顏色&風格設定
    ...(color === 'warning' &&
      variant === 'contained' && {
        backgroundColor: theme.palette.error.main,
        '&:hover': {
          backgroundColor: theme.palette.error.light,
        },
        '&:active': {
          backgroundColor: theme.palette.error.dark,
        },
      }),
    ...(color === 'primary' &&
      variant === 'contained' && {
        '&:hover': {
          backgroundColor: theme.palette.green.secondary,
        },
        '&:active': {
          backgroundColor: theme.palette.primary.mainPlus2,
        },
      }),
    ...(color === 'neutral' &&
      variant === 'contained' && {
        color: theme.palette.white.main,
        backgroundColor: theme.palette.neutral.main,
        '&:hover': {
          backgroundColor: theme.palette.neutral.light,
        },
        '&:active': {
          backgroundColor: theme.palette.neutral.dark,
        },
      }),
  })
)

const ButtonBasic = ({
  children,
  size = 'large',
  startIcon,
  endIcon,
  variant = 'contained',
  color = 'primary',
  disabled = false,
  fullWidth = false,
  onClick,
  ...props
}) => {
  return (
    <StyledButton
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      variant={variant}
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledButton>
  )
}

export default ButtonBasic
